import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { IEntityPagination } from 'viggo-sistemas-core-web/modules/core/model/entity.model';
import { IPreDeposito } from '../models/pre_deposito.model';

@Injectable()
export class PreDepositoService extends EntityService<IPreDeposito> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'pre_deposito'
    });
  }

  /**
   * Retorna uma lista vazia
   * @param where
   * @returns
   */
  callsReturnEmpty(where: any) {
    return of({
      data: [],
      pagination: {
        page_size: 0,
        page: 0,
        total: 0
      }
    } as any).pipe(
      map(data => {
        if (where.require_pagination) {
          data = data as IEntityPagination<any>;
          return {
            data: [],
            pagination: data.pagination
          };
        }
        data = data as any[];
        return data;
      }),
      catchError(this.handleError)
    );
  }

  /**
   * Função responsável por listar os itens de um pre_deposito
   * @param where
   * @returns
   */
  getItens(where: any) {
    if (where['mp_id'] !== undefined || where['mpv_id'] !== undefined) {
      var url = `${this.baseURL}/itens`;
      var params = new HttpParams();

      if (where) {
        if (typeof where === 'object') {
          Object.keys(where).forEach(key => {
            if (where[key] !== null && where[key] !== undefined) {
              if (Array.isArray(where[key])) {
                params = params.append(`${key}`, where[key].join(','));
              } else {
                params = params.append(`${key}`, where[key]);
              }
            }
          });
        }
      }

      if (params.get('domain_id') === '') {
        params = params.set('domain_id', this.tokenService.getDomain().id);
      }

      return this.http
        .get<any>(url, {
          params: params,
          headers: this.getHeader()
        })
        .pipe(
          map(data => {
            if (where.require_pagination) {
              data = data as IEntityPagination<any>;
              return {
                data: data[this.entitiesName],
                pagination: data.pagination
              };
            }
            data = data as any[];
            return data[this.entitiesName];
          }),
          catchError(this.handleError)
        );
    } else return this.callsReturnEmpty(where);
  }
}
